import { Injectable } from '@angular/core';
import { SharedUtilService } from './shared-util.service';

@Injectable({
  providedIn: 'root'
})
export class LocalAcaVoicesService {
  constructor(private sharedUtilService: SharedUtilService
  ) {
    localStorage.setItem('miniboardinited', 'false');
  }
  getLocalAcaVoices(): Promise<any> {
    return new Promise((resolve, reject) => {
      if ((<any>window).nodeRequire) {
        try {
          const spawn = (<any>window).nodeRequire('child_process').spawn;
          let commandpath = `${__dirname}`;
          //commandpath = commandpath.substring(0, commandpath.length - 8);
          //commandpath = 'e:/personal/resources/app/dist/inde.html';
          
          //alert(commandpath.substr(0, commandpath.lastIndexOf('resources') + 9));
          // alert(commandpath);
          //this.cancel();
          //commandpath = '';
          //wait a moment for add chmod +x
          if (this.sharedUtilService.getSystem() == 'windows') {
            let resourcesIndex = commandpath.lastIndexOf('resources');
            if (resourcesIndex > -1) {
              commandpath = commandpath.substr(0, resourcesIndex + 9);
              commandpath = commandpath + '\\app\\dist\\pwa-personal-web\\assets\\native\\acaforelectron.exe';
            } else {
              commandpath = commandpath + '/assets/native/acaforelectron.exe';
            }
            
            //alert(commandpath);
            const ls = spawn(commandpath, ['voice']);
            let resultStr = '';
            ls.stdout.on('data', (data) => {
              //console.log(`stdout: ${data}`);
              const s = `${data}`;
              resultStr += s;
            });
            ls.stderr.on('data', (data) => {
             // console.log(`stderr: ${data}`);

            });

            ls.on('close', (code) => {
                console.log(`child process exited with code ${code}`);
                //resolve([]);
                if (code === 0) {
                  var voices = resultStr.split('\n');
                  if (this.sharedUtilService.startWith(resultStr, 'Voice: ')) {
                    resolve(voices);
                  }
                }
            });
          } else {
            const ls = spawn(commandpath + '/assets/native/acaforelectron', ['voice']);
            ls.stderr.on('data', (data) => {
              //console.log(`stdout: ${data}`);
            });
            // let list: any = {};
            //list.system = 
            let resultStr = '';
            ls.stdout.on('data', (data) => {
              //console.log(`stderr: ${data}`);
              const s = `${data}`;
              resultStr += s;
              // const resIndex = s.indexOf('result#');
              // if (resIndex > -1) {
              //   const jsonS = s.substr(resIndex + 7);
              //   //list.push.apply(list, JSON.parse(jsonS));
              //   list.aca = JSON.parse(jsonS);
              //   resolve(list);
              // }
              // const sysResIndex = s.indexOf('systemresult#');
              // if (sysResIndex > -1) {
              //   const jsonS = s.substr(sysResIndex + 13);
              //   //list.push.apply(list, JSON.parse(jsonS));
              //   list.system = JSON.parse(jsonS);
              // }
            });

            ls.on('close', (code) => {
              // console.log(`child process exited with code ${code}`);
              // console.log(code + resultStr);
              if (code === 0) {
                try {
                  const vlist = JSON.parse(resultStr);
                  resolve(vlist);
                  // if (vlist.system.length > 0 && vlist.aca.length > 0) {
                  //   resolve(vlist);
                  // }
                } catch (err) {
                  console.log("err in parsing vlist");
                  //resolve([]);
                }
              } else {
                resolve([]);
              }
            });
          }

        } catch (error) {
          //throw error;
          console.log("err in getting aca voices");
          resolve([]);
        }
      } else {
        console.warn('Could not load electron');
        resolve([]);
      }
    });
  }
}
